import type { Ref } from "react";

interface SideNavRowLabelProps {
    label: string;
    labelClassName: string;
    labelRef: Ref<HTMLSpanElement>;
}

export const SideNavRowLabel = ({
    label,
    labelClassName,
    labelRef,
}: SideNavRowLabelProps) => (
    <span ref={labelRef} className={labelClassName} data-side-nav-label>
        {label}
    </span>
);
